import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React from "react";
import { Link } from "react-router-dom";
import { MoreVertIcon, List, ListItem, ListItemText, Divider, Popover } from "../../";

var SMPopover = function SMPopover(_ref) {
  var data = _ref.data,
      type = _ref.type,
      labels = _ref.labels;

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      anchorEl = _React$useState2[0],
      setAnchorEl = _React$useState2[1];

  var _id = data[0];
  var actions = [];

  var createContent = function createContent() {
    switch (type) {
      case "contacts":
        labels.forEach(function (label) {
          actions.push({
            name: label.name,
            label: label.label,
            route: "/".concat(type, "/").concat(_id, "/").concat(label.name)
          });
        });
        return /*#__PURE__*/React.createElement(List, {
          key: "popover_" + _id,
          component: "div",
          disablePadding: true
        }, actions.map(function (_ref2) {
          var name = _ref2.name,
              route = _ref2.route,
              label = _ref2.label;
          return /*#__PURE__*/React.createElement(ListItem, {
            component: Link,
            to: route,
            button: true,
            key: "".concat(name, "-").concat(_id),
            onClick: function onClick() {// console.log("route onClick Popover");
              // console.log(route);
            }
          }, /*#__PURE__*/React.createElement(ListItemText, {
            primary: label
          }));
        }), /*#__PURE__*/React.createElement(Divider, null));

      case "tasks":
        labels.forEach(function (label) {
          actions.push({
            name: label.name,
            label: label.label,
            onItemClick: label.onItemClick
          });
        });
        return /*#__PURE__*/React.createElement(List, {
          key: "popover_" + _id,
          component: "div",
          disablePadding: true
        }, actions.map(function (_ref3) {
          var name = _ref3.name,
              onItemClick = _ref3.onItemClick,
              label = _ref3.label;
          return /*#__PURE__*/React.createElement(ListItem, {
            "data-cy": name,
            button: true,
            key: "".concat(name, "-").concat(_id),
            onClick: function onClick() {
              onItemClick(name, _id);
            }
          }, /*#__PURE__*/React.createElement(ListItemText, {
            primary: label
          }));
        }), /*#__PURE__*/React.createElement(Divider, null));

      case "invoices":
        // console.log("data", data);
        // console.log("type", type);
        // console.log("labels", labels);
        return /*#__PURE__*/React.createElement(List, {
          key: "popover_" + _id,
          component: "div",
          disablePadding: true
        }, labels.map(function (item) {
          return createItemPopover(item);
        }));

      case "template":
        return /*#__PURE__*/React.createElement(List, {
          key: "popover_" + _id,
          component: "div",
          disablePadding: true
        }, labels.map(function (item) {
          return createItemPopover(item);
        }));

      default:
        actions.push({
          name: "view",
          label: "Ver",
          route: "/".concat(type, "/").concat(_id, "/view")
        }, {
          name: "edit",
          label: "Editar",
          route: "/".concat(type, "/").concat(_id, "/edit")
        }, {
          name: "disable",
          label: "Desactivar",
          route: "/".concat(type, "/").concat(_id, "/delete")
        });
        return /*#__PURE__*/React.createElement(List, {
          key: "popover_" + _id,
          component: "div",
          disablePadding: true
        }, actions.map(function (_ref4) {
          var name = _ref4.name,
              route = _ref4.route,
              label = _ref4.label;
          return /*#__PURE__*/React.createElement(ListItem, {
            component: Link,
            to: route,
            button: true,
            key: "".concat(name, "-").concat(_id),
            onClick: function onClick() {// console.log("route onClick Popover");
              // console.log(route);
            }
          }, /*#__PURE__*/React.createElement(ListItemText, {
            primary: label
          }));
        }), /*#__PURE__*/React.createElement(Divider, null));
    }
  };

  var createItemPopover = function createItemPopover(item) {
    switch (item.variant) {
      case "component":
        return /*#__PURE__*/React.createElement(ListItem, null, item.component);

      case "link":
        return /*#__PURE__*/React.createElement(ListItem, {
          component: Link,
          to: item.route,
          button: true,
          key: "".concat(item.name, "-").concat(item._id)
        }, " ", /*#__PURE__*/React.createElement(ListItemText, {
          primary: item.label
        }));

      case "button":
        return /*#__PURE__*/React.createElement(ListItem, {
          button: true,
          key: "".concat(item.name, "-").concat(_id),
          onClick: function onClick() {
            item.onItemClick(item.name, _id);
          }
        }, /*#__PURE__*/React.createElement(ListItemText, {
          primary: item.label
        }));

      default:
        break;
    }
  };

  var handleClick = function handleClick(event) {
    setAnchorEl(event.currentTarget);
  };

  var handleClose = function handleClose() {
    setAnchorEl(null);
  }; // const handleDialog = () => {
  // 	setDialogOpen(!dialogOpen);
  // };


  var open = Boolean(anchorEl);
  return [/*#__PURE__*/React.createElement(MoreVertIcon, {
    "data-cy": "options",
    onClick: function onClick(e) {
      handleClick(e); //console.log(data);
    }
  }), /*#__PURE__*/React.createElement(Popover, {
    "data-cy": "popover",
    open: open,
    anchorEl: anchorEl,
    onClose: handleClose,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "left"
    }
  }, createContent()) // <div>{dialogContent}</div>
  ];
};

export { SMPopover };